/**
 * @generated SignedSource<<8be3b7036b16a198294a6fc07a67545c>>
 * @relayHash 85cdcdcc59285ab862ab240d1bee9dae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8a5448bc0a3497061f9c64dc0e8112f555531895dd0363125ecda59fd71a6a94

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookLogsQuery } from './PlaybookLogsQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookLogsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8a5448bc0a3497061f9c64dc0e8112f555531895dd0363125ecda59fd71a6a94",
    "metadata": {},
    "name": "PlaybookLogsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
